import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Suppliers from '@features//supplier/component/Suppliers';

const BrandWiseSupplierList = () => {
	const brandProfileStore = useSelector((store) => store.brandProfileStore);
	const { id } = useParams();
	let additionalFilter = { brandIds: [{ id, name: brandProfileStore.name }], runningBrandId: id };

	return (
		<div className="tab-contents supplier">
			<Suppliers
				requestFrom={'CRM'}
				additionalFilters={additionalFilter}
				isShowMarginColumn={true}
				isShowShipCountColumn={true}
				isShowOnTimeColumn={true}
				isShowDevelopmentValue={false}
				isSaveViewType={false}
			/>
		</div>
	);
};

export default BrandWiseSupplierList;
